export const scriptTypes = {
	VIEW_REALTIME_SCRIPT_ANALYSIS: 'VIEW_REALTIME_SCRIPT_ANALYSIS',
	VIEW_REALTIME_SCRIPT_ANALYSIS_ERROR: 'VIEW_REALTIME_SCRIPT_ANALYSIS_ERROR',

	VIEW_REALTIME_SCRIPT_TECHNICAL_ANALYSIS : 'VIEW_REALTIME_SCRIPT_TECHNICAL_ANALYSIS',
	VIEW_REALTIME_SCRIPT_TECHNICAL_ANALYSIS_ERROR : 'VIEW_REALTIME_SCRIPT_TECHNICAL_ANALYSIS_ERROR'
};
